export default "__VITE_ASSET__Djfe4Ffw__"